import { clsx } from 'clsx'

import styles from './styles.module.scss'

//
//

export const FullCenterContent = ({
  children,
  animation,
  fixPosition,
  //
  //
  allowOverflow,
}) => (
  <div
    className={clsx(styles['full-center-content'], {
      [animation]: animation,
      [styles['full-center-content_fix-position']]: fixPosition,
      [styles['full-center-content_allow-overflow']]: allowOverflow,
    })}
  >
    {children}
  </div>
)
